import React, { useState, useEffect } from 'react';

const Step2Bank = ({ setCurrentStep, setTransactionDetails }) => {
   const [isConfirmed, setIsConfirmed] = useState(false);
   const [depositCode, setDepositCode] = useState('');
   const [isLoading, setIsLoading] = useState(true);
   const [isSubmitting, setIsSubmitting] = useState(false);
   const [error, setError] = useState(null);

   // Función para obtener el código de depósito
   useEffect(() => {
      const fetchDepositCode = async () => {
         setIsLoading(true);
         try {
            const jwt = localStorage.getItem('jwt');
            if (!jwt) {
               throw new Error('No authentication token found');
            }

            const response = await fetch('https://pt-api.digit-a.net/api/deposit/deposit-usd/create-code', {
               method: 'GET',
               headers: {
                  'Authorization': `Bearer ${jwt}`,
                  'Content-Type': 'application/json'
               }
            });

            if (!response.ok) {
               throw new Error(`Error: ${response.status} - ${response.statusText}`);
            }

            const data = await response.json();
            console.log('Deposit code response:', data);
            setDepositCode(data.code);
         } catch (err) {
            console.error('Error fetching deposit code:', err);
            setError(err.message);
         } finally {
            setIsLoading(false);
         }
      };

      fetchDepositCode();
   }, []);

   const handleCheckboxChange = (e) => {
      setIsConfirmed(e.target.checked);
   };

   const handleContinue = async () => {
      setIsSubmitting(true);
      try {
         const jwt = localStorage.getItem('jwt');
         if (!jwt) {
            throw new Error('No authentication token found');
         }

         // Enviamos el código de depósito a la API
         const response = await fetch('https://pt-api.digit-a.net/api/deposit/deposit-usd/create-transaction', {
            method: 'POST',
            headers: {
               'Authorization': `Bearer ${jwt}`,
               'Content-Type': 'application/json'
            },
            body: JSON.stringify({
               depositCode: depositCode,
               currency: 'USD'
            })
         });

         if (!response.ok) {
            throw new Error(`Error: ${response.status} - ${response.statusText}`);
         }

         const data = await response.json();
         console.log('Transaction response:', data);

         // Guardamos los detalles de la transacción para usarlos en StepThanks
         if (setTransactionDetails && data.transaction) {
            // Asegurarse de que la transacción tenga todos los campos necesarios
            const transactionData = {
               ...data.transaction,
               // Si el monto es 0 o no está definido, usar un valor por defecto
               amount: data.transaction.amount || 0
            };
            setTransactionDetails(transactionData);
         }

         // Avanzamos al siguiente paso
         setCurrentStep(4);
      } catch (err) {
         console.error('Error creating transaction:', err);
         setError(err.message);
      } finally {
         setIsSubmitting(false);
      }
   };

   return (
      <div className="modal_content_body text-center">
         <h3 className="ppt_form_title mb-4 text-center">Wire, ACH & Swift Bank Transfer</h3>
         <div className='ppt_deposit_item'>
            <p className="col-lg-9 mx-lg-auto">
               <strong>Bank Details</strong>
            </p>
            <small className="d-block col-lg-10 mx-lg-auto">
               <strong className="text-danger">
                  <img
                     src={process.env.PUBLIC_URL + '/assets/img/icon_warning_red.svg'}
                     alt=""
                     style={{ width: '14px', transform: 'translateY(-1px)' }}
                  /> Important:
               </strong> Deposit USD ($) only to the provided bank account details. Ensure the transfer is made from an account registered under the same name as the ProperT account holder, and include your transfer ID in the notes section. Funds may take up to 10 business days to reflect in your account.
            </small>
            <small className="d-block col-lg-10 mx-lg-auto">
               <strong>Account Number:</strong> 8765 7682 8634 9273<br />
               <strong>SWIFT Number:</strong> BVA0999<br />
               <strong>Account Name:</strong> ProperT LLC<br />
               <strong>Bank Address:</strong> Avenue Beach 17<br />
               <strong>Transfer ID</strong> (must include in transfer description to receive tokens):
               {isLoading ? (
                  <em className='idtoken'> Loading ID...</em>
               ) : error ? (
                  <em className='idtoken text-danger'> Error loading ID. Please refresh.</em>
               ) : (
                  <em className='idtoken'> {depositCode}</em>
               )}
               <br />
            </small>
            <div className="d-flex justify-content-center gap-3 flex-column">
               <div className="ppt_input_style">
                  <div>
                     <input
                        type="checkbox"
                        className="form-checkbox"
                        id="ppt_input_checkout_confirm_bank"
                        onChange={handleCheckboxChange}
                        checked={isConfirmed}
                        disabled={isLoading || error}
                     />
                     <label htmlFor="ppt_input_checkout_confirm_bank">
                        <small>I confirm I have made the transfer.</small>
                     </label>
                  </div>
               </div>
               <button
                  className="ppt_btn_primary alt"
                  disabled={!isConfirmed || isLoading || error || isSubmitting}
                  onClick={handleContinue}
               >
                  {isSubmitting ? 'Processing...' : 'Continue'}
               </button>
               {error && (
                  <p className="text-danger mt-2">
                     <small>There was an error. Please try again later.</small>
                  </p>
               )}
            </div>
         </div>
      </div>
   );
};

export default Step2Bank;